import React from "react";
import { useStoreState, useStoreActions } from "easy-peasy";
import { types as actionTypes } from "../lib/store";
import { useTranslation } from "react-i18next";

import FrequencySlider from "./Simulation/FrequencySlider";

const types = {
  FREQUENCY: "FREQUENCY"
};

const Simulation = () => {
  const { t } = useTranslation();

  const { can_change_frequency } = useStoreState(
    state => state.selection.fan.simulation
  );

  const simulationType = useStoreState(state => {
    return state.selection.customizations.simulationType;
  });

  const updateSimulationType = useStoreActions(
    actions => actions.selection[actionTypes.CHANGE_SIMULATION_TYPE]
  );

  const updateStore = e => {
    e.preventDefault();
    updateSimulationType({ type: e.target.value });
  };

  const show_simulation_panel = can_change_frequency;

  return (
    <>
      {show_simulation_panel && (
        <div className="panel panel-info">
          <div className="panel-heading">
            {t("frontend:fan.simulation.panel_title")}
          </div>
          <div className="panel-body">
            <form className="form-horizontal">
              <select
                className="form-control"
                onChange={updateStore}
                value={simulationType}
              >
                <option value="">
                  {t("frontend:fan.simulation.select_type")}
                </option>
                {can_change_frequency && (
                  <option value={types.FREQUENCY}>
                    {t("frontend:fan.simulation.frequency")}
                  </option>
                )}
              </select>
            </form>
            {can_change_frequency &&
              simulationType === types.FREQUENCY && <FrequencySlider />}
          </div>
        </div>
      )}
    </>
  );
};

export default Simulation;

export {
  types
};
